<form [formGroup]="internalForm">
    <div *ngIf="showDeposit" class="payment-choice-box">
        <h3>{{'PASSENGERS_PAYMENT_CHOICE' | resource:'Passengers'}}</h3>
        <div class="row">
            <div class="column small-12 field">
                <input formControlName="payment" id="depositRadio" name="payment" type="radio" value="deposit-payment">
                <label for="depositRadio">
                    <span class="deposit-data"> {{ depositInstructions }} </span>
                </label>
            </div>
        </div>
    </div>
    <div class="payment-choice-box">
        <div *ngIf="showDeposit" class="row">
            <div class="column small-12 field">
                <input formControlName="payment" id="fullPaymentRadio" name="payment" type="radio" value="full-payment">
                <label for="fullPaymentRadio">
                    <span class="full"> {{ fullPaymentInstructions }} </span>
                </label>
            </div>
        </div>
        <h3>{{'PASSENGERS_CAMPAIGN_CODE_TITLE' | resource:'Passengers'}}</h3>
        <div id="campaign-code-container" class="">
            <div class="row">
                <div class="column small-12 xlarge-6">
                    <div class="row">
                        <div class="column small-12">
                            <div class="row collapse inline-right secondary-action-form">
                                <div class="column small-6 medium-8 field">
                                    <input [disableControl]="isDepositSeleted()" formControlName="campaignCode" type="text">
                                </div>
                                <div class="column small-6 medium-4 label">
                                    <sbw-button [state]="internalForm.pending ? 'spinner' : 'activated'" type="secondary" onClickState="activated" [text]="'PASSENGERS_CAMPAIGN_CODE_VERIFY' | resource:'Passengers'"></sbw-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column small-12 xlarge-6 validation-message">
                    <div class="row">
                        <div class="column small-12">
                            <span *ngIf="campaignCode.dirty && campaignCode.valid" class="field-validation-ok">{{'PASSENGERS_CAMPAIGN_CODE_VALID' | resource:'Passengers'}}</span>
                            <span *ngIf="campaignCode.dirty && campaignCode.invalid" class="field-validation-error">{{campaignCode.errors.errorMessage.message}}</span>
                        </div>
                    </div>
                </div>
                <div class="column small-12 gutter">
                    <sbw-info-popup [text]="'PASSENGERS_CAMPAIGN_CODE_POPUP' | resource:'Passengers'"></sbw-info-popup>
                    {{'PASSENGERS_CAMPAIGN_CODE_NOTE' | resource:'Passengers'}}
                </div>
            </div>
        </div>
    </div>
</form>
